/* global window */
/*
* Using fetch method for downloading pdf files.
*/
import Resources from '../helpers/resources';

export default function fetcher(
    url,
    filename
) {
    return window.fetch(url, {
        headers: {
            AuthToken: Resources.env.authToken
        }
    })
        .then((res) => {
            if (res.status !== 200) {
                throw new Error(res.statusText || 'Unknown fetcher status message');
            }
            return res.blob();
        })
        .then((resObj) => {
            const newBlob = new window.Blob([resObj], { type: 'application/pdf' });

            const href = window.URL.createObjectURL(newBlob);
            const link = window.document.createElement('a');
            link.href = href;
            link.download = filename;
            window.document.body.appendChild(link);
            link.click();
            window.document.body.removeChild(link);
        })
        .catch((err) => {
            // eslint-disable-next-line no-console
            console.error('fetcher.js - ', err);
            throw new Error(`fetcher.js - ${err}`);
        });
}



// WEBPACK FOOTER //
// ./helpers/fetcher.js